import { connect } from 'react-redux';
import { productionTimeOptionsSelector } from '../../../../../../redux/product/product.selectors';
import { productionTimeBlockDispatcher } from '../../../../../../redux/product/product.dispatchers';
import { ProductionTimeBlockComponent } from './production-time-block';
export const ProductionTimeBlock = connect(productionTimeOptionsSelector, productionTimeBlockDispatcher)(ProductionTimeBlockComponent);